<template>
  <div v-if="card" transition="modal" class="backdrop" v-on:click="dismissModal">
    <form class="edit-card-form create" v-on:submit.prevent="update" v-on:click.stop="">
      <textarea class="create-card-title" name="title" v-model="card.title" placeholder="Title"></textarea>
      <div class="create-pick-snippet">
          <h5>Pick a snippet</h5>
          <input type="radio" value="image" v-model="card.show" /><label>image</label>
          <input type="radio" value="text" v-model="card.show" /><label>text snippet</label>
          <input type="radio" value="" v-model="card.show" /><label>none</label>
      </div>
      <img :src="card.image" class="card-image" v-if="card.show === 'image'" />
      <textarea class="create-text-snippet" name="snippet" v-model="card.snippet" placeholder="text snippet" rows="6" v-if="card.show === 'text'"></textarea>
      <textarea name="description" v-model="card.description" placeholder="why learn this?" rows="5" class="create-card-why"></textarea>
      <button type="submit">Done</button>
    </form>
  </div>
</template>

<script>
  import cardRepository from '../../data/CardRepository'
  import EventBus from '../EventBus'
  export default {
    //props: ['card'],
    data() {
      return {
        card: null
      }
    },
    created: function () {
      EventBus.$on('card.selected', this.selectCard)
    },
    beforeDestroy: function () {
      EventBus.$off('card.selected', this.selectCard)
    },
    methods: {
      selectCard: function(card){
        this.card = card
        
      },
      remove () {
        cardRepository.remove(this.card, (err) => {
          if (err) throw err // TODO: inform the user
          this.dismissModal()
        })
      },
      update () {
        cardRepository.update(this.card, (err) => {
          if (err) throw err // TODO: inform the user
          this.dismissModal()
        })
      },
      dismissModal () {
        this.card = null
      }
    }
  }
</script>

<style>

  
</style>


// WEBPACK FOOTER //
// UpdateModal.vue?098626ae